export default __webpack_public_path__ + "static/media/fresher.14f2aadd.png";